// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"798":"f6033111","1656":"8ba45fd4"}[chunkId] + ".chunk.css";
};